class StatisticDirective
  @$inject: ['Device']
  constructor: (Device)->              
    class Statistic
      restrict: "A"
      controllerAs: "$statistic"
      controller: ($scope, $element, $attrs)->
        statistic = Device.statistic()
        @get = ()=>
          return statistic

        return @
     
    return new Statistic()

  
module.exports = StatisticDirective


// WEBPACK FOOTER //
// ./src/component/device/statistic/statistic.coffee